<template>
  <form @submit.prevent class="info-form style01 lounge-filters" v-if="results">
    <div class="heading-area">
      <span class="icon-holder">
        <i class="icon-lounges"></i>
      </span>
      <span class="text">{{ $t('banner.lounges') }}</span>
    </div>

    <input-date-time v-model="quote" :label="$t('airportlounge.filters.departure_date')" dateProp="dateA" timeProp="timeA" :time="true" :wrapper="false" />
        
    <div class="input-col style02">
      <label class="label-text" for="text04">{{ $t('airportlounge.filters.adults') }}</label>
      <div class="select-wrap">
        <span class="fake-select">
          <select id="select-1" v-model="adults">
            <option 
              v-for="(option, key) in 6" 
              :key="key" 
              :selected="adults === option" 
              :value="option.toString()">{{ option }}</option>
          </select>
        </span>
      </div>
    </div>
    <div class="input-col">
      <label class="label-text" for="text05">{{ $t('airportlounge.filters.children') }}</label>
      <div class="select-wrap">
          <span class="fake-select">
          <select id="select-1" v-model="children">
            <option :value="0" selected>0</option>
            <option 
              v-for="(option, key) in 6" 
              :key="key" 
              :selected="children === option" 
              :value="option.toString()">{{ option }}</option>
          </select>
        </span>
      </div>
    </div>
    <div class="input-col">
      <label class="label-text" for="text06">{{ $t('airportlounge.filters.infants') }}</label>
      <div class="select-wrap">
        <span class="fake-select">
          <select id="select-1" v-model="infants">
            <option :value="0" selected>0</option>
            <option 
              v-for="(option, key) in 2" 
              :key="key" 
              :selected="infants === option" 
              :value="option.toString()">{{ option }}</option>
          </select>
        </span>
      </div>
    </div>
    <button @click="search" class="submit" type="button">{{ $t('airporthotel.filters.search') }}</button>
  </form>
</template>

<script>
import { get, sync } from "vuex-pathify";
import { eventBus } from "@/eventBus";
import { InputDateTime } from "@/components";
import mixins from "@/mixins";

export default {
  name: "hotel-filters",
  components: { InputDateTime },
  mixins: [mixins.format],
  computed: {
    results: get("results/products"),
    ...sync("quoteTemp/*"),
    quote: sync("quoteTemp"),
  },
  methods: {
    search(e) {
      e.preventDefault();
      eventBus.$emit("SEARCH");   
    },
  }
};
</script>